<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App"
};
</script>

<style>
#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  width: 100%;
  margin: 0 auto;
  /* background: rgb(187, 235, 176); */
}
.amap-sug-result {
z-index: 9999999999999999 !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue